export default __webpack_public_path__ + "static/patient-guide--breast-cancer-1539441adbfb3f7a2c9e179e251105b2.jpg";